/**
 * Private modules
 */
const {
  accountId,
  accountType,
  apiKey,
  customerId,
  drawId,
  hasEmployer,
  hasSelf,
  identity,
  isActivated,
  isRemoved,
  nickname,
  objectId,
  systemId,
  username,
} = require('../.private').components;

/**
 * Constant variables
 */
const login = {
  properties: {
    customerId: {
      format: 'uuid',
      type: [
        'null',
        'string',
      ],
    },
    isActivated,
    isRemoved,
    nickname,
    objectId,
    type: accountType,
    username,
  },
  required: [
    'customerId',
    'isActivated',
    'isRemoved',
    'nickname',
    'objectId',
    'type',
    'username',
  ],
  type: 'object',
};
const systemGameId = {
  default: null,
  oneOf: [
    {
      pattern: '^\\d+$',
      type: 'string',
    },
    {
      type: 'number',
    },
    {
      type: 'null',
    },
  ],
};
const systemGameTypeId = {
  default: null,
  oneOf: [
    {
      pattern: '^\\d+$',
      type: 'string',
    },
    {
      type: 'number',
    },
    {
      type: 'null',
    },
  ],
};
module.exports = {
  accessAccountId: {
    properties: {
      body: {
        properties: {
          accountId,
          options: {
            properties: {
              hasEmployer,
              hasSelf,
            },
            required: [
              'hasEmployer',
              'hasSelf',
            ],
            type: 'object',
          },
          systemGameId,
        },
        required: [
          'accountId',
          'options',
          'systemGameId',
        ],
        type: 'object',
      },
      login,
    },
    required: [
      'body',
      'login',
    ],
    type: 'object',
  },
  accessCustomerId: {
    properties: {
      body: {
        properties: {
          customerId,
          options: {
            properties: {
              hasEmployer,
              hasSelf,
            },
            required: [
              'hasEmployer',
              'hasSelf',
            ],
            type: 'object',
          },
          systemGameId,
        },
        required: [
          'customerId',
          'options',
          'systemGameId',
        ],
        type: 'object',
      },
      login,
    },
    required: [
      'body',
      'login',
    ],
    type: 'object',
  },
  accessDrawCustomerId: {
    properties: {
      body: {
        properties: {
          customerId,
          drawId,
          options: {
            properties: {
              hasEmployer,
              hasSelf,
            },
            required: [
              'hasEmployer',
              'hasSelf',
            ],
            type: 'object',
          },
          systemGameId,
          systemGameTypeId,
        },
        required: [
          'customerId',
          'drawId',
          'options',
          'systemGameId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
      login,
    },
    required: [
      'body',
      'login',
    ],
    type: 'object',
  },
  accessDrawId: {
    properties: {
      body: {
        properties: {
          drawId,
        },
        required: ['drawId'],
        type: 'object',
      },
      login,
    },
    required: [
      'body',
      'login',
    ],
    type: 'object',
  },
  accessSystemId: {
    properties: {
      body: {
        properties: {
          systemId,
        },
        required: ['systemId'],
        type: 'object',
      },
    },
    required: ['body'],
    type: 'object',
  },
  authorizeApiKey: {
    properties: {
      body: {
        properties: {
          apiKey,
        },
        required: ['apiKey'],
        type: 'object',
      },
    },
    required: ['body'],
    type: 'object',
  },
  checkPermission: {
    properties: {
      body: {
        properties: {
          identity,
        },
        required: ['identity'],
        type: 'object',
      },
      login,
    },
    required: [
      'body',
      'login',
    ],
    type: 'object',
  },
  getAccessibleAccountIds: {
    properties: {
      body: {
        properties: {
          options: {
            properties: {
              hasEmployer,
              hasSelf,
            },
            required: ['hasEmployer',
              'hasSelf'],
            type: 'object',
          },
          systemGameId,
        },
        required: [
          'options',
          'systemGameId',
        ],
        type: 'object',
      },
      login,
    },
    required: [
      'body',
      'login',
    ],
    type: 'object',
  },
  getAccessibleCustomerIds: {
    properties: {
      body: {
        properties: {
          options: {
            properties: {
              hasEmployer,
              hasSelf,
            },
            required: [
              'hasEmployer',
              'hasSelf',
            ],
            type: 'object',
          },
          systemGameId,
        },
        required: [
          'options',
          'systemGameId',
        ],
        type: 'object',
      },
      login,
    },
    required: [
      'body',
      'login',
    ],
    type: 'object',
  },
  getAccessibleDrawCustomerIds: {
    properties: {
      body: {
        properties: {
          drawId: {
            default: null,
            format: 'uuid',
            type: [
              'null',
              'string',
            ],
          },
          options: {
            properties: {
              hasEmployer,
              hasSelf,
            },
            required: [
              'hasEmployer',
              'hasSelf',
            ],
            type: 'object',
          },
          systemGameId,
          systemGameTypeId,
        },
        required: [
          'drawId',
          'options',
          'systemGameId',
          'systemGameTypeId',
        ],
        type: 'object',
      },
      login,
    },
    required: [
      'body',
      'login',
    ],
    type: 'object',
  },
  getAccessibleDrawDates: {
    properties: {
      login,
    },
    required: [
      'login',
    ],
    type: 'object',
  },
  getAccessibleDrawIds: {
    properties: {
      login,
    },
    required: [
      'login',
    ],
    type: 'object',
  },
};
